import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { AvailableSubscriptionsInterface } from "@features/subscriptions/interfaces/available-subscriptions.interface";
import { PayableProductInterface } from "@features/subscriptions/interfaces/payable-product.interface";
import { PaymentsApiCheckoutSessionInterface } from "@features/subscriptions/interfaces/payments-api-checkout-session.interface";
import { PaymentsApiConfigInterface } from "@features/subscriptions/interfaces/payments-api-config.interface";
import { PricingInterface } from "@features/subscriptions/interfaces/pricing.interface";
import { UpgradePricingInterface } from "@features/subscriptions/interfaces/upgrade-pricing.interface";
import { UpgradeResponseInterface } from "@features/subscriptions/interfaces/upgrade-response.interface";
import { RecurringUnit } from "@features/subscriptions/types/recurring.unit";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class PaymentsApiService {
  constructor(public readonly http: HttpClient) {}

  public getConfig(): Observable<PaymentsApiConfigInterface> {
    return this.http.get<PaymentsApiConfigInterface>(`${environment.classicBaseUrl}/payments/config/`);
  }

  public createCheckoutSession(
    userId: number,
    product: PayableProductInterface,
    currency: string,
    recurringUnit: RecurringUnit,
    autorenew: boolean
  ): Observable<PaymentsApiCheckoutSessionInterface> {
    return this.http.post<PaymentsApiCheckoutSessionInterface>(
      `${environment.classicBaseUrl}/payments/create-checkout-session/${userId}/${product}/${currency}/${recurringUnit}/${autorenew}/`,
      {}
    );
  }

  public upgradeSubscription(
    userId: number,
    product: PayableProductInterface,
    currency: string,
    recurringUnit: RecurringUnit
  ): Observable<UpgradeResponseInterface> {
    return this.http.post<UpgradeResponseInterface>(
      `${environment.classicBaseUrl}/payments/upgrade-subscription/${userId}/${product}/${currency}/${recurringUnit}/`,
      {}
    );
  }

  public getPrice(
    product: PayableProductInterface,
    currency: string,
    recurringUnit: RecurringUnit
  ): Observable<PricingInterface> {
    return this.http.get<PricingInterface>(
      `${environment.classicApiUrl}/api/v2/payments/pricing/${product}/${currency}/${recurringUnit}/`
    );
  }

  public getAvailableSubscriptions(): Observable<AvailableSubscriptionsInterface> {
    return this.http.get<AvailableSubscriptionsInterface>(
      `${environment.classicApiUrl}/api/v2/payments/pricing/available-subscriptions/`
    );
  }

  public getUpgradePricing(
    product: PayableProductInterface,
    currency: string,
    recurringUnit: RecurringUnit
  ): Observable<UpgradePricingInterface> {
    return this.http.get<UpgradePricingInterface>(
      `${environment.classicApiUrl}/api/v2/payments/upgrade-pricing/${product}/${currency}/${recurringUnit}/`
    );
  }
}
